const key = "add-vessel-entity-schema";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/131$/);
};

const vesselExtendedPropertiesSchema = {
	type: "object",
	title: "Extended Properties",
	properties: {
		SimpleValue: {
			type: "string",
			title: "Simple Value"
		},
		Engine: {
			type: "object",
			title: "Engine",
			description: "...",
			properties: {
				Horsepower: { 
					title: "Horsepower",
					type: "integer" 
				}
			}
		},
		Electronics: {
			type: "object",
			title: "Electronics",
			properties: {
				SideScanSonar: { 
					title: "Side Scan Sonar",
					type: "boolean",
					format: "checkbox"
				},
				Fathometer: { 
					title: "Fathometer",
					type: "boolean",
					format: "checkbox"
				}
			}
		},
		Lighting: {
			type: "object",
			title: "Lighting",
			properties: {
				AttractingLightsUsed: {
					type: "array",
					title: "Attracting Lights Used",
					items: {
						type: "object",
						title: "Light",
						properties: {
							type: {
								type: "string",
								title: "Type",
								enum: ["Type 1", "Type 2"]
							},
							wattage: {
								type: "integer",
								title: "Wattage",
								minimum: 0
							},
							number: {
								type: "integer",
								title: "Number",
								minimum: 1
							}
						}
					}
				}
			}
		}
	},
	required: ["Engine", "Electronics"]
};

const modify = (resp) => {
	const vesselType = resp.data.Data.Agency.Types.find(type => type.Code === "VESSEL");

	if(vesselType) {
		vesselType.Schema = vesselExtendedPropertiesSchema;
	}

	return resp;
};

export const addVesselEntitySchema = [key, applicable, modify];